import React from "react";
import { useTranslation } from "react-i18next";

const DeletionInstruction = () => {
    const { t } = useTranslation();

    const steps = [
        {
            id: 1,
            title: t("Open the LiBooking App"),
            desc: t("Open the LiBooking app on your mobile device and make sure you are logged in to your account."),
            img: "/asset/delete-1.jpg",
        },
        {
            id: 2,
            title: t("Go to Settings"),
            desc: t("Tap on your profile icon or menu, then navigate to the Settings page."),
            img: "/asset/delete-11.jpg",
        },
        {
            id: 3,
            title: t("Select Delete Account"),
            desc: t("Scroll down until you find the 'Delete Account' option, then click on it."),
            img: "/asset/delete-2.jpg",
        },
        {
            id: 4,
            title: t("Confirm Deletion"),
            desc: t("Enter your password to confirm and complete the deletion process."),
            img: "/asset/delete-3.jpg",
        },
    ];

    return (
        <div className="max-w-5xl mx-auto px-6 py-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-4 text-center">
                {t("How to Delete Your LiBooking Account")}
            </h1>
            <p className="text-gray-600 text-center mb-10 max-w-2xl mx-auto">
                {t(
                    "If you wish to delete your LiBooking account, follow the simple steps below. You can perform the process easily from the app at any time."
                )}
            </p>

            <div className="flex flex-col gap-12">
                {steps.map((step, index) => (
                    <div
                        key={step.id}
                        className={`flex flex-col md:flex-row items-center gap-6 ${index % 2 !== 0 ? "md:flex-row-reverse" : ""
                            }`}
                    >
                        <div className="flex-1">
                            <div className="text-blue-600 font-bold text-lg mb-1">
                                {t("Step")} {step.id}
                            </div>
                            <h2 className="text-xl font-semibold text-gray-800 mb-2">
                                {step.title}
                            </h2>
                            <p className="text-gray-600 leading-relaxed">{step.desc}</p>
                        </div>

                        <div className="flex-1 ">
                            <div className=" h-[500px]">
                               <img
                                src={step.img}
                                alt={`Step ${step.id}`}
                                className="rounded-xl shadow-md border border-gray-200   h-full "
                            /> 
                            </div>
                            
                        </div>
                    </div>
                ))}
            </div>

            {/* ملاحظات */}
            <div className="mt-12 bg-blue-50 border border-blue-100 rounded-xl p-6 text-gray-700 leading-relaxed">
                <h3 className="text-lg font-semibold text-blue-700 mb-3">
                    {t("Important Notes")}
                </h3>
                <ul className="list-disc list-inside space-y-2">
                    <li>{t("You will not be able to recover your account or any information afterward.")}</li>
                    <li>{t("Please cancel any active bookings before requesting deletion.")}</li>
                </ul>
            </div>

            {/* الدعم */}
            <p className="mt-10 text-center text-gray-600">
                {t("Need help? Contact our support team at")}{" "}
                <a
                    href="mailto:support@libooking.com"
                    className="text-blue-600 font-medium hover:underline"
                >
                    info@libooking.com
                </a>
            </p>
        </div>
    );
};

export default DeletionInstruction;
